var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.visibleButtons),function(button,i){return _c('li',{key:i},[_c('base-button',{attrs:{"icon":button.icon,"text":button.text},on:{"click":button.func}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }